import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearEventsAction, getMyEventsAction } from '../../redux/actions/eventsActions';

const useFetchEvents = () => {
  const dispatch = useDispatch();
  const date = useSelector((state) => state.events?.date);
  const events = useSelector((state) => state.events?.events);
  const loading = useSelector((state) => state.events?.loading);

  const fetchEvents = useCallback(async () => {
    await dispatch(getMyEventsAction(date));
  }, [date, dispatch]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  useEffect(() => {
    return () => {
      dispatch(clearEventsAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchEvents();
  };

  return { loading, events, refresh };
};

export default useFetchEvents;
